<template>

  <div style="width: 500px">


    <table v-bind:style="!editable ? 'pointer-events: none;' : '' ">
      <tr>
        <th class="parameterText">LoD multiplier :</th>
        <th style="border: none"><input :readonly="!editable" type="text" v-model="metadata.LODMultiplier"
                                        @change="onMetadataOutChanged"/></th>
      </tr>
      <tr>
        <th class="parameterText">LoQ multiplier :</th>
        <th style="border: none"><input :readonly="!editable" type="text" v-model="metadata.LOQMultiplier"
                                        @change="onMetadataOutChanged"/></th>
      </tr>

    </table>

  </div>


</template>

<script>
import {Component, Prop, Vue} from "vue-property-decorator";


@Component({})
export default class CalibrationGraphMultipliers extends Vue {

  @Prop() editable = false;
  @Prop() metadata = {};

  onMetadataOutChanged() {
    this.$emit("change");
  }

}

</script>


<style scoped>
input:read-only {
  border: none;
  pointer-events: none;
}

.parameterText {
  text-align: right;
  width: 1%;
  white-space: nowrap;
  border: none;

}
</style>
